import { render, staticRenderFns } from "./CMSItem2.vue?vue&type=template&id=13732657&scoped=true&"
import script from "./CMSItem2.vue?vue&type=script&lang=js&"
export * from "./CMSItem2.vue?vue&type=script&lang=js&"
import style0 from "./CMSItem2.vue?vue&type=style&index=0&id=13732657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13732657",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDivider,VList,VListGroup,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VNavigationDrawer,VSkeletonLoader})
